'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { listRecentCalcs, type RecentCalcEntry } from '@/lib/recent-calcs'
import { CALC_SLUG_TO_TYPE } from '@/components/calc/use-calc-telemetry'
import { cn } from '@/lib/utils'

/** tipo de analytics → rota da calculadora (primeiro slug que mapeia pro tipo). */
const TYPE_TO_HREF: Record<string, string> = Object.entries(CALC_SLUG_TO_TYPE).reduce(
  (acc, [slug, tipo]) => {
    if (!acc[tipo]) acc[tipo] = `/calculadoras/${slug}`
    return acc
  },
  {} as Record<string, string>,
)

/**
 * "Seus últimos cálculos" (TASK-04) — mostra os até 3 cálculos persistidos
 * no localStorage do anônimo. Não renderiza nada na primeira visita.
 */
export function RecentCalcsStrip({ className }: { className?: string }) {
  const [calcs, setCalcs] = useState<RecentCalcEntry[]>([])

  useEffect(() => {
    setCalcs(listRecentCalcs())
  }, [])

  if (calcs.length === 0) return null

  return (
    <div className={cn('border border-line bg-surface', className)}>
      <div className="flex items-baseline justify-between border-b border-line-soft px-4 py-2">
        <span className="text-[12px] font-bold text-ink">Seus últimos cálculos</span>
        <span className="text-[11px] text-ink-faint">salvos neste navegador</span>
      </div>
      <ul className="divide-y divide-line-soft">
        {calcs.map((c) => (
          <li key={c.id}>
            <Link
              href={TYPE_TO_HREF[c.source] ?? '/calculadoras'}
              className="group flex items-baseline justify-between gap-4 px-4 py-2.5"
            >
              <span className="min-w-0">
                <span className="block text-[13px] font-semibold text-ink group-hover:text-brand">
                  {c.title}
                </span>
                <span className="block truncate font-mono text-[12px] text-ink-mute">
                  {c.summary}
                </span>
              </span>
              <span className="shrink-0 text-[12px] font-semibold text-brand opacity-0 transition-opacity group-hover:opacity-100">
                Refazer →
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <p className="border-t border-line-soft px-4 py-2 text-[11.5px] text-ink-faint">
        Quer levar pro celular?{' '}
        <Link href="/sign-up" className="font-semibold text-brand hover:underline">
          Crie conta grátis
        </Link>{' '}
        e sincronize.
      </p>
    </div>
  )
}
